export default __webpack_public_path__ + "static/philosophie_texture-26af8da695c2f3657e19d98b416fd333.png";